export enum UsMapRangeType {
  firstRange = 1,
  secondRange = 2,
  thirdRange = 3,
  fourthRange = 4,
  fifthRange = 5,
  sixthRange = 6,
  seventhRange = 7,
}
